// Restricted email configuration for sidebar access control
export const RESTRICTED_EMAILS = new Set([
  'vivacious.parakeet.qazd@hidingmail.com',
  'akaushik@getquantic.com'
]);

export const ALLOWED_SECTIONS_FOR_RESTRICTED = new Set([
  'Overview',
  'Restaurants API',
  'MenuBuilder API',
]);

interface SidebarSection {
  title: string;
  items: any[];
}

/**
 * Filters sidebar sections based on user email restrictions
 * Returns all sections if no email (production companies),
 * filtered sections if user is restricted, or all sections otherwise
 */
export const filterSectionsByUser = (
  sections: SidebarSection[],
  userEmail?: string | null
): SidebarSection[] => {
  // If no email (production companies), show all sections
  if (!userEmail) return sections;
  
  // If restricted email, show only allowed sections
  return RESTRICTED_EMAILS.has(userEmail)
    ? sections.filter(({ title }) => ALLOWED_SECTIONS_FOR_RESTRICTED.has(title))
    : sections;
};
